<template>
  <v-container>
      Redirecting ...
  </v-container>
</template>

<script>
import SearchBoxService from '../../services/searchBox.service';

export default {
    created(){
        
        this.wsid = this.$route.params.wsid;
        this.urlid = this.$route.params.urlid;
        this.rqid = this.$route.params.rqid;
        this.mlv = this.$route.params.mlv;
        
        this.loadCityAirports();
    },
    methods:{
        loadCityAirports(){
            SearchBoxService.getCityAirports("").then(rslt=>{
                this.cityAirports = rslt.data;
                this.storeSearchCriteria();
            });
        },        
        getCityAirport(code){
            let linq = new this.$linq(this.cityAirports);
            let ca = linq.where(c=>c.substring(0,3)==code).toArray();
            return ca[0];
        },        
        storeSearchCriteria(){
            SearchBoxService.decodeFlightSearchBoxValues(this.rqid).then((rslt)=>{
                let srchCri = rslt.data;

                this.searchPara.wholesaleId = this.wsid;
                this.searchPara.urlId = this.urlid;
                this.searchPara.trip = srchCri.Trip;
                this.triptype = srchCri.TripType;
                if(srchCri.TripType=="M"){
                    this.searchPara.origin  = srchCri.Origin;
                    this.searchPara.destination = srchCri.Destination;
                }else{
                    this.searchPara.origin  = this.getCityAirport(srchCri.Origin);
                    this.searchPara.destination = this.getCityAirport(srchCri.Destination);
                }
                
                this.searchPara.markupLevel = this.mlv;

                setTimeout(()=>{

                    this.searchPara.departureDate = srchCri.DepartureDate;
                    this.searchPara.returnDate = srchCri.ReturnDate;
                    this.searchPara.seatClass = srchCri.SeatClass;
                    this.searchPara.adtPassengerCount = srchCri.AdultCount;
                    this.searchPara.cnnPassengerCount = srchCri.ChildCount;
                    this.searchPara.infPassengerCount = srchCri.InfantCount;
                    this.searchPara.stuPassengerCount = srchCri.StudentCount;
                    this.searchPara.airline = srchCri.Airline;

                    this.$store.commit('updateSearchBoxValues',this.searchPara);
                    this.$store.commit('updateMarkupLevel',this.mlv);
                    this.$store.commit('updatetrip',this.triptype);
                    setTimeout(()=>{
                        this.$router.push(
                            {
                                name:'FlightSearchByAgentSearchBox',
                                params:{
                                    wsid:this.wsid,
                                    urlid:this.urlid,
                                    mlv:this.mlv,
                                }
                            });
                    },2000);  

                },1000);
              
            });
        }
    },
    data(){
        return {
            cityAirports:null,
            wsid:0,
            urlid:0,
            rqid:"",
            mlv:1,
            searchPara:{
                wholesaleId:35,
                urlId:382,
                trip:"",
                airline:"--",
                origin:"",
                destination:"",
                departureDate:"",
                returnDate:"",
                seatClass:"",
                adtPassengerCount:0,
                cnnPassengerCount:0,
                infPassengerCount:0,
                stuPassengerCount:0,
                markupLevel:1,
                styleName:"1G1",
                language:"EN",
                flightType:"0",              
            }, 
            triptype:"",      
        }
    }
}
</script>

<style>

</style>